<template>
  <el-dialog title="审批任务"
             class="approveTaskClass"
             :visible.sync="dialogVisible">
    <el-form ref="form"
             :model="approveInfo"
             label-width="100px">
      <el-form-item label="不通过原因">
        <el-input type="textarea"
                  :rows="4"
                  v-model="approveInfo.Memo"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="saveApprove">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken } from "../../util/auth";
import {
  GetTaskSettingByTaskType,
  GetTaskBusinessByTaskId,
  GetTaskStateSettingByTaskType,
  ApproveTask
} from "@/api/modules/basicData/basicTask.js";

const cookieUser = getToken();
export default {
  data() {
    return {
      dialogVisible: false,
      approveInfo: { Success: false }
    };
  },

  computed: {
    curTask() {
      return this.$store.state.task.curTask;
    }
  },
  methods: {
    saveApprove() {
      this.dialogVisible = false;
      this.$emit("triggerEnd", Object.assign({}, this.approveInfo));
      this.approveInfo = { Success: false };
    }
  }
};
</script>

<style scoped>
.approveTaskClass {
  text-align: left;
}
</style>